<!-- Итог фоновой синхронизации ЭДО с количеством успешных и проблемных документов. -->
<template>
  <section class="edo-sync-result" aria-live="polite">
    <div class="edo-sync-result__header">
      <span class="edo-sync-result__icon" aria-hidden="true">✓</span>
      <div>
        <h3>Отчёт о синхронизации</h3>
        <p>Обработано документов: {{ result.total }}</p>
      </div>
    </div>

    <dl class="edo-sync-result__stats">
      <div>
        <dt>Успешно</dt>
        <dd>{{ result.succeeded }}</dd>
      </div>
      <div :class="{ 'edo-sync-result__stat--remarks': result.failed > 0 }">
        <dt>С замечаниями</dt>
        <dd>{{ result.failed }}</dd>
      </div>
    </dl>

    <button
      v-if="displayedFailedDocuments.length && !showRemarks"
      type="button"
      class="edo-sync-result__show-remarks"
      @click="showRemarks = true"
    >
      Посмотреть замечания
    </button>

    <div v-if="showRemarks" class="edo-sync-result__errors">
      <h4>Замечания по документам</h4>
      <EdoSyncDocumentError
        v-for="failedDocument in displayedFailedDocuments"
        :key="failedDocument.external_id"
        :document-number="failedDocument.document_number || failedDocument.external_id"
        :error="failedDocument.error"
      />
    </div>
  </section>
</template>

<script>
import EdoSyncDocumentError from "@/components/Edo/shared/SyncDocumentError.vue";

export default {
  name: "EdoSyncResult",

  components: {
    EdoSyncDocumentError,
  },

  props: {
    result: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      showRemarks: false,
    };
  },

  computed: {
    displayedFailedDocuments() {
      return this.result.failedDocuments;
    },

  },
};
</script>

<style scoped>
.edo-sync-result {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.edo-sync-result__header {
  display: flex;
  gap: 10px;
  align-items: flex-start;
}

.edo-sync-result__icon {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #dcfce7;
  color: #15803d;
  font-weight: 700;
}

.edo-sync-result h3,
.edo-sync-result h4,
.edo-sync-result p {
  margin: 0;
}

.edo-sync-result h3 {
  color: #1e293b;
  font-size: 15px;
}

.edo-sync-result__header p {
  margin-top: 3px;
  color: #64748b;
  font-size: 13px;
}

.edo-sync-result__stats {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin: 0;
}

.edo-sync-result__stats > div {
  padding: 10px 12px;
  border-radius: 8px;
  background: #f1f5f9;
}

.edo-sync-result__stats dt {
  color: #64748b;
  font-size: 12px;
}

.edo-sync-result__stats dd {
  margin: 3px 0 0;
  color: #0f172a;
  font-size: 20px;
  font-weight: 700;
}

.edo-sync-result__stat--remarks {
  background: #fffbeb !important;
}

.edo-sync-result__stat--remarks dd {
  color: #a16207;
}

.edo-sync-result__errors {
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: 190px;
  overflow-y: auto;
  padding-right: 4px;
}

.edo-sync-result__show-remarks {
  align-self: flex-start;
  padding: 7px 10px;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  background: #fff;
  color: #334155;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
}

.edo-sync-result__show-remarks:hover {
  border-color: #94a3b8;
  background: #f8fafc;
}

.edo-sync-result__errors h4 {
  color: #334155;
  font-size: 14px;
}

</style>
